var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import screenfull from 'screenfull';
function enter(elevent) {
  if (screenfull.isEnabled) {
    if (screenfull.isFullscreen) {
      if (elevent && 'target' in elevent && elevent.target instanceof Element) {
        var element = elevent instanceof Element ? elevent : 'target' in elevent && elevent.target instanceof Element ? elevent.target : null;
        if (element === screenfull.element) {
          screenfull.exit();
        }
      }
    }
    if (!elevent) {
      return screenfull.request();
    } else if (elevent instanceof Element) {
      return screenfull.request(elevent);
    } else if ('target' in elevent && elevent.target instanceof Element) {
      return screenfull.request(elevent.target);
    } else {
      return screenfull.request();
    }
  }
  return Promise.resolve();
}
// type UseScreenfull = {
//   isFullscreen: boolean
//   requestFullscreen: (
//     element?: Element | Event | React.MouseEvent,
//   ) => Promise<void>
//   toggle: () => Promise<void>
// }
function useFullscreen() {
  var _a = __read(React.useState(screenfull.isEnabled && screenfull.isFullscreen), 2),
    isFullscreen = _a[0],
    setIsFullscreen = _a[1];
  var handler = React.useCallback(function () {
    if (screenfull.isEnabled) {
      // console.log('Am I fullscreen?', screenfull.isFullscreen ? 'Yes' : 'No')
      setIsFullscreen(screenfull.isFullscreen);
    } else {
      // console.log('Screenfull not enabled')
    }
  }, []);
  var exit = function () {
    if (screenfull.isEnabled) {
      return screenfull.exit();
    }
  };
  var toggle = React.useMemo(function () {
    return function () {
      if (screenfull.isEnabled) {
        return screenfull.toggle();
      }
      return Promise.resolve();
    };
  }, []);
  React.useEffect(function () {
    if (screenfull.isEnabled) {
      screenfull.on('change', handler);
    }
    return function () {
      if (screenfull.isEnabled) screenfull.off('change', handler);
    };
  }, []);
  return {
    isActive: isFullscreen,
    isAvailable: screenfull.isEnabled,
    enter: enter,
    exit: exit,
    className: isFullscreen ? 'is-fullscreen' : '',
    toggle: toggle,
    toggleOnClick: function (e) {
      e.stopPropagation();
      toggle();
    },
    enterOnClick: function (e) {
      e.stopPropagation();
      enter();
    },
    exitOnClick: function (e) {
      e.stopPropagation();
      exit();
    }
  };
}
function useFullscreenError() {
  var _a = __read(React.useState(null), 2),
    error = _a[0],
    setError = _a[1];
  React.useEffect(function () {
    if (screenfull.isEnabled) {
      screenfull.on('error', setError);
    }
    return function () {
      if (screenfull.isEnabled) screenfull.off('error', setError);
    };
  }, []);
  return error;
}
export { useFullscreen, useFullscreenError };